const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const token = () => localStorage.getItem('token') || localStorage.getItem('vincentrix_token') || '';
const dealerId = () => {
  try {
    for (const key of ['dealership','dealer','vincentrix_dealer']) {
      const raw=localStorage.getItem(key); if(!raw) continue; const parsed=JSON.parse(raw); if(parsed?.id) return parsed.id;
    }
  } catch {}
  return '';
};
const headers=()=>({'Content-Type':'application/json',...(token()?{Authorization:`Bearer ${token()}`} : {}),...(dealerId()?{'X-Dealership-Id':dealerId()}:{})});

const fetchCustomers=async()=>{const r=await fetch(`${API_URL}/api/customers`,{headers:headers()});if(!r.ok)throw new Error('Unable to load acquisition record');const d=await r.json();return d.customers||[]};
const updateCustomer=async(id,patch)=>{const r=await fetch(`${API_URL}/api/customers/${id}`,{method:'PUT',headers:headers(),body:JSON.stringify(patch)});if(!r.ok)throw new Error('Unable to stamp acquisition completion');return r.json()};

const matchCustomer=async drawer=>{
  const text=drawer.innerText||'';
  const vin=text.match(/VIN\s+([A-HJ-NPR-Z0-9]{17})/i)?.[1];
  const customers=await fetchCustomers();
  if(vin){const match=customers.find(c=>String(c.vin||'').toUpperCase()===vin.toUpperCase());if(match)return match}
  return customers.find(c=>c.name&&text.includes(c.name))||null;
};

let busy=false;
document.addEventListener('click',async event=>{
  const button=event.target.closest('button');
  if(!button||!String(button.textContent||'').toLowerCase().includes('save opportunity')||busy)return;
  const drawer=button.closest('.vc-opportunity-drawer');if(!drawer)return;
  const stage=[...drawer.querySelectorAll('select')].find(select=>[...select.options].some(option=>option.value==='acquired'));
  if(!stage||stage.value!=='acquired')return;
  busy=true;
  try{
    await new Promise(resolve=>setTimeout(resolve,500));
    const customer=await matchCustomer(drawer);if(!customer)return;
    if(String(customer.acquisitionStatus||'').toLowerCase()!=='acquired')return;
    if(customer.acquiredAt)return;
    const now=new Date().toISOString();
    const activity=[...(Array.isArray(customer.acquisitionActivity)?customer.acquisitionActivity:[]),{
      id:`acquired-${Date.now()}`,type:'acquired',actor:'Dealership Team',source:'Acquisition CRM',title:'Vehicle acquisition completed',detail:`Purchased for ${customer.purchasePrice?`$${Number(String(customer.purchasePrice).replace(/[^0-9.]/g,'')).toLocaleString()}`:'recorded purchase price'}`,timestamp:now
    }].slice(-250);
    await updateCustomer(customer.id,{acquiredAt:now,acquisitionCompletedAt:now,acquisitionAttribution:customer.acquisitionAttribution||(customer.sydneyPipelineAutomated?'Sydney + VinCentrix':'VinCentrix'),acquisitionActivity:activity,acquisitionUpdatedAt:now});
  }catch(error){console.warn('Acquisition completion stamp failed:',error)}finally{busy=false}
},true);
